import NativeSafeSelect from "../ui/NativeSafeSelect.jsx";

import {
  PASSENGER_ASSET_TYPES,
  PERFORMER_CATEGORIES,
  performerCategoryLabel,
  performerText,
} from "./performerCatalog.js";

// REISOR_PHASE3A_PERFORMER_CATEGORY_SELECT_V3

export default function PerformerCategorySelect({
  form,
  setForm,
  setError,
  language,
  inputStyle,
  labelStyle,
  hintStyle,
}) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  const choose = (value) => {
    setError("");

    setForm((prev) => {
      const category =
        String(value || "").toUpperCase();

      const next = {
        ...prev,
        performerCategory: category,
      };

      if (category === "CARGO") {
        return {
          ...next,
          assetType: "TRUCK",
          bodyType:
            prev.performerCategory === "CARGO"
              ? prev.bodyType
              : "",
          bodyTypeOther:
            prev.performerCategory === "CARGO"
              ? prev.bodyTypeOther
              : "",
          seats: "",
          passengerServices: [],
        };
      }

      if (category === "SPECIAL") {
        return {
          ...next,
          assetType: "SPECIAL_EQUIPMENT",
          bodyType: "Спецтехника",
          bodyTypeOther:
            prev.performerCategory === "SPECIAL"
              ? prev.bodyTypeOther
              : "",
          capacityTons: "",
          volumeM3: "",
          seats: "",
          passengerServices: [],
        };
      }

      if (category === "TOW") {
        return {
          ...next,
          assetType: "TOW_TRUCK",
          bodyType: "Спецтехника",
          bodyTypeOther: "Эвакуатор",
          capacityTons: "",
          volumeM3: "",
          seats: "",
          passengerServices: [],
        };
      }

      if (category === "PASSENGER") {
        return {
          ...next,
          assetType:
            prev.performerCategory === "PASSENGER" &&
            PASSENGER_ASSET_TYPES.includes(prev.assetType)
              ? prev.assetType
              : "CAR",
          bodyType: "Пассажирский",
          bodyTypeOther: "",
          capacityTons: "",
          volumeM3: "",
          passengerServices:
            prev.performerCategory === "PASSENGER" &&
            Array.isArray(prev.passengerServices)
              ? prev.passengerServices
              : [],
        };
      }

      return {
        ...next,
        assetType: "",
        bodyType: "",
        bodyTypeOther: "",
        capacityTons: "",
        volumeM3: "",
        seats: "",
        passengerServices: [],
      };
    });
  };

  return (
    <>
      <div style={labelStyle}>
        {tx("Категория", "Тоифа", "Kategori")}
      </div>

      <NativeSafeSelect
        value={form.performerCategory}
        onChange={choose}
        style={{ ...inputStyle, color: "white" }}
        ariaLabel={tx(
          "Категория исполнителя",
          "Ижрочи тоифаси",
          "Uygulayıcı kategorisi"
        )}
        options={[
          {
            value: "",
            label: tx(
              "Выберите категорию",
              "Тоифани танланг",
              "Kategori seçin"
            ),
          },
          ...PERFORMER_CATEGORIES.map((value) => ({
            value,
            label: performerCategoryLabel(
              value,
              language
            ),
          })),
        ]}
      />

      {form.performerCategory &&
       form.performerCategory !== "CARGO" ? (
        <div
          style={{
            ...hintStyle,
            marginTop: -2,
            padding: "10px 12px",
            borderRadius: 14,
            border:
              "1px solid rgba(59,130,246,.35)",
            background:
              "rgba(37,99,235,.10)",
          }}
        >
          {tx(
            "Категория сохраняется отдельно и не смешивается с грузовыми заказами.",
            "Тоифа алоҳида сақланади ва юк буюртмалари билан аралаштирилмайди.",
            "Kategori ayrı tutulur ve yük işleriyle karıştırılmaz."
          )}
        </div>
      ) : null}
    </>
  );
}
